/**
 * お問い合わせ種類: その他のお問い合わせ
 */
export const CONTACT_CLASSIFICATION_OTHER = 1;
/**
 * お問い合わせ種類: カジュアル相談会
 */
export const CONTACT_CLASSIFICATION_CASUAL = 2;
